import { render, staticRenderFns } from "./WoocommerceProductItem.vue?vue&type=template&id=0825bb28&scoped=true&lang=pug&"
import script from "./WoocommerceProductItem.vue?vue&type=script&lang=js&"
export * from "./WoocommerceProductItem.vue?vue&type=script&lang=js&"
import style0 from "./WoocommerceProductItem.vue?vue&type=style&index=0&id=0825bb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825bb28",
  null
  
)

/* custom blocks */
import block0 from "./WoocommerceProductItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VLayout,VRow})
